/**
 * The key to the cleaned-zone colouring: "Cleaned  today ▮▮▮ 3 d+ / never",
 * and the live accent for a zone being cleaned now.
 *
 * NOT A CONTROL (Akash, 2026-10-22): no slider, no picker, nothing to tap.
 * The switches and the threshold live in Preferences; a view says only what
 * its colours mean. It takes no pointer events, so a tap through it still
 * reaches the drawing.
 *
 * Shown only where the colouring is on. `inline` sits in the 2D map's control
 * row beside the dock key; the default floats over the Building view.
 */
import { staleLegendText } from './cleaned-zones';
import './CleanedLegend.css';

export const CLEANED_LEGEND_LABEL = 'Cleaned';
export const CLEANED_LEGEND_FRESH = 'today';
export const CLEANED_LEGEND_NOW = 'cleaning now';

export function CleanedLegend({ days, inline = false }: { days: number; inline?: boolean }) {
  return (
    <div
      className={`nx-cleaned-legend${inline ? ' nx-cleaned-legend--inline' : ''}`}
      data-testid="cleaned-legend"
      aria-label={`Zone colours: green was cleaned today, fading to grey at ${days} days; grey is ${days} days or more, or never.`}
    >
      <span className="nx-cleaned-legend__label">{CLEANED_LEGEND_LABEL}</span>
      <span>{CLEANED_LEGEND_FRESH}</span>
      <span className="nx-cleaned-legend__ramp" aria-hidden="true" />
      <span>{staleLegendText(days)}</span>
      <span className="nx-cleaned-legend__now">
        <span className="nx-cleaned-legend__dot" aria-hidden="true" />
        {CLEANED_LEGEND_NOW}
      </span>
    </div>
  );
}
